import React from 'react';
import PercentTendencyFloat from '@gp/components/PercentTendencyFloat';
import TriggerFoldBtn from '@gp/components/TriggerFoldBtn';
import InfoBubble from '@gp/components/InfoBubble';
import ProjectItem from '@gp/components/ProjectItem';
import TextAreaMore from '@gp/components/TextAreaMore';
import { TABLE_COMMON_COL_HEADER_MAP, DATA_SOURCE_MAP } from './constants';
import { getFormatNumPlus, getNumberOfDotUnit } from '@gp/utils/common';
import { ifCanGoToDetailsByGameType } from '@gp/utils/project';

// 公共列表体每项加下边框效果，只有第一行有这种效果
// const addBorderBottomLine = (e: any) => {
//   return (
//     <>
//       {e}
//       <span className="border-bottom-line"></span>
//     </>
//   );
// };

// 公共列表体
const commonCol = (value: string, percent: number) => {
  // if (!value && !percent && String(value) !== '0' && String(percent) !== '0') return '-';

  return (
    <div className="dbg-table-metrics">
      <span className="dbg-table-metrics-value">{getFormatNumPlus(value || '')}</span>
      <PercentTendencyFloat className="dbg-table-metrics-precent" value={percent} />
    </div>
  );
};

// 获取列配置
const getColumns = (
  isHideExpandButton: boolean,
  unFoldList: string[],
  setUnFoldList: React.Dispatch<React.SetStateAction<string[]>>,
  count: number,
  date: string,
  triggerFoldExpand: boolean,
  toDetails,
  isNeedData = false,
  projects,
) => {
  // 组织公共列配置
  const orgCol = TABLE_COMMON_COL_HEADER_MAP.map((t: CommonColHeaderItemType) => {
    const headers: [string, string] = t.title.split('\n') as [string, string];
    const headerFirTxt = headers[0]?.replace('<time>', date || '-');
    const headerSecTxt = headers[1];
    // 展开项中存在或者拥有子类时，正常宽度显示，否则宽度为0不展示
    const width = !triggerFoldExpand
      ? unFoldList?.includes(t.groupKey) || t.isGroup
        ? t.width
        : 0
      : t.width;

    return {
      key: t.keyName,
      header: (
        <div
          className={`dbg-table-header-flex ${width == 0 ? 'dbg-table-header-flex--nowrap' : ''}`}
        >
          <div className="dbg-table-header-icon">
            {t.dataSource && (
              <InfoBubble
                className="dbg-table-header-datasource-bubble"
                DomOrText={
                  <img width={20} height={20} src={DATA_SOURCE_MAP.svg[t.dataSource]} alt="" />
                }
                customBubbleContent={
                  <div className="dbg-table-header-datasource-bubble-inner">
                    Data of {DATA_SOURCE_MAP.metric[t.metric]} comes from &nbsp;
                    <img
                      width={18}
                      height={18}
                      src={DATA_SOURCE_MAP.bubblesvg[t.dataSource]}
                      alt=""
                    />
                    &nbsp;
                    {DATA_SOURCE_MAP.name[t.dataSource]}.
                  </div>
                }
              />
            )}
          </div>
          <div className="dbg-table-header-text">
            {headerFirTxt}
            <br />
            {headerSecTxt}
          </div>
          {
            // !isHideExpandButton && !!t.isGroup && (
            // <div
            //   className="header-fold-btn"
            //   style={{
            //     zIndex:
            //       t.keyName === 'total_mau' &&
            //       !unFoldList?.includes(
            //         'total_mau',
            //       ) /* 展开项中不包含total_mau */
            //         ? 0
            //         : 10,
            //   }}
            //   onClick={(e: any) => {
            //     e.stopPropagation();
            //   }}
            // >
            //   <TriggerFoldBtn
            //     foldBubble="Expand by platform"
            //     state={unFoldList?.includes(t?.keyName)}
            //     onClick={() => {
            //       // 判断展开列表中是否存在，存在的话，删除展开列表中的key，不存在的话，把key加到展开项中
            //       const index = unFoldList?.findIndex(
            //         (item: string) => item === t.keyName,
            //       );
            //       const newUnFoldList =
            //         index >= 0
            //           ? unFoldList?.filter(
            //               (item: string) => item !== t.keyName,
            //             )
            //           : [...unFoldList, t.keyName];
            //       setUnFoldList(newUnFoldList);
            //       // 展开最后一项时，往右滚动到最右边，让用户知道后面还有展开的列，增强用户体验
            //       if (index === -1 && t?.keyName === 'total_mau') {
            //         const t = setTimeout(() => {
            //           const tableBodyEl: any = document.querySelector(
            //             '.gp-studio-overall-details-projects-live-breakdown .dbg-breakdown-list-table .tea-table__body',
            //           );
            //           if (tableBodyEl) {
            //             const currentWidth = tableBodyEl.offsetWidth,
            //               scrollLeft = tableBodyEl.scrollLeft,
            //               scrollWidth = tableBodyEl.scrollWidth;
            //             // 出现滚动条时，此时自动向右滚动到最右边
            //             if (scrollWidth - currentWidth > 0) {
            //               tableBodyEl.scrollLeft = scrollWidth - currentWidth;
            //             }
            //           }
            //           clearTimeout(t);
            //         }, 200);
            //       }
            //     }}
            //   />
            // </div>
            // )
          }
        </div>
      ),
      align: 'right',
      width,
      render: (cvm: any) => {
        return width ? <> {commonCol(cvm?.[t.keyName], cvm?.[`${t.keyName}_ratio`])}</> : null;
      },
    };
  });

  return [
    {
      key: 'projects',
      // header: (<span>Project{count > 0 ? 's' : ''} ({count > 0 ? count - 1 : 0})</span>),
      header: <span>Projects ({getNumberOfDotUnit(count)})</span>,
      align: 'left',
      fixed: 'left',
      width: 240,
      render: (cvm: any) => {
        return (
          <div className="new-td">
            {['All Games', 'All Games']?.includes(cvm?.game_name) ? (
              'All Games'
            ) : (
              <ProjectItem
                src={cvm?.game_cover || ''}
                title={cvm?.game_name || '-'}
                platform={cvm?.platform || ''}
                platformPlaceHolder="-"
                toDetails={ifCanGoToDetailsByGameType(cvm, projects) ? toDetails : null}
                data={isNeedData ? cvm : null}
              />
            )}
          </div>
        );
      },
    },
    {
      key: 'genre',
      header: <span>Genre</span>,
      align: 'left',
      width: 140,
      render: (cvm: any) => {
        return (
          <div className="new-td">
            <InfoBubble
              className="globalpedia-modal-font14"
              customBubbleContent={
                cvm?.genre || cvm?.sub_genre ? (
                  <>
                    <div className="bubble-genre">
                      Genre: {cvm?.genre?.replaceAll('|', ', ') || '-'}
                    </div>
                    <div className="bubble-sub-genre">
                      Sub Genre: {cvm?.sub_genre?.replaceAll('|', ', ') || '-'}
                    </div>
                  </>
                ) : undefined
              }
              DomOrText={
                <TextAreaMore
                  className="gp-word-break-word"
                  type="ellipsis"
                  isMustNoButton
                  text={cvm?.genre?.replaceAll('|', ', ') || '-'}
                  ellipsisLineClamp={2}
                />
              }
            />
          </div>
        );
      },
    },
    ...orgCol,
  ];
};

export { getColumns };
